export class ComponentService {
    pageComponents = {};
    webContentComponents = {};

    registerPageComponents = (pageComponents = {}) => {
        this.pageComponents = { ...this.pageComponents, ...pageComponents };
    };

    registerWebContentComponents = (webContentComponents = {}) => {
        this.webContentComponents = { ...this.webContentComponents, ...webContentComponents };
    };

    getPageComponents = () => {
        return Object.keys(this.pageComponents).reduce((lowerCased, key) => {
                lowerCased[key.toLowerCase()] = this.pageComponents[key];

                return lowerCased;
        }, {});
    };

    getWebContentComponents = () => {
        return Object.keys(this.webContentComponents).reduce((lowerCased, key) => {
                lowerCased[key.toLowerCase()] = this.webContentComponents[key];

                return lowerCased;
        }, {});
    };
}

export const componentService = new ComponentService();
